import { exists } from '@/api'

export interface SystemCheckError {
  dbConfigurations: string[]
  collectionAndUserChecks: string[]
  lendAndReturnConditions: string[]
  reservationConditions: string[]
  alerts: string[]
}

export const defaultSystemCheckError = (): SystemCheckError => ({
  dbConfigurations: [],
  collectionAndUserChecks: [],
  lendAndReturnConditions: [],
  reservationConditions: [],
  alerts: []
})

export function SystemCheckErrorFromJSON(json: any): SystemCheckError {
  return {
    dbConfigurations: exists(json, 'db_configurations')
      ? json.db_configurations
      : [],
    collectionAndUserChecks: exists(json, 'collection_and_user_checks')
      ? json.collection_and_user_checks
      : [],
    lendAndReturnConditions: exists(json, 'lend_and_return_conditions')
      ? json.lend_and_return_conditions
      : [],
    reservationConditions: exists(json, 'reservation_conditions')
      ? json.reservation_conditions
      : [],
    alerts: exists(json, 'alerts') ? json.alerts : []
  }
}
